const prefix = 'SETUP_SETTING_WORKFLOW';

// Rule Type
export const SET_RULE_VALUE = `${prefix}_SET_RULE_VALUE`;
export const SET_ALL_RULE_VALUE = `${prefix}_SET_ALL_RULE_VALUE`;
export const RESET_RULES = `${prefix}_RESET_RULES`;

// Criteria Type
export const SET_CRITERIA_LOGIC = `${prefix}_SET_CRITERIA_LOGIC`;
export const ADD_CRITERIA = `${prefix}_ADD_CRITERIA`;
export const SET_ALL_CRITERIA = `${prefix}_SET_ALL_CRITERIA`;
export const REMOVE_CRITERIA = `${prefix}_REMOVE_CRITERIA`;
export const UPDATE_CRITERIA_BY_COLUMN = `${prefix}_UPDATE_CRITERIA_BY_COLUMN`;
export const RESET_CRITERIA = `${prefix}_RESET_CRITERIA`;

// Meta Type
export const SET_META_DATA_FIELDS = `${prefix}_SET_META_DATA_FIELDS`;
export const SET_META_CONDITIONS = `${prefix}_SET_META_CONDITIONS`;
export const SET_META_CONTEXT = `${prefix}_SET_META_CONTEXT`;
export const SET_SIDER = `${prefix}_SET_SIDER`;
export const RESET_SIDER = `${prefix}_RESET_SIDER`;
export const SET_TRIGGER_META_OBJECT_OPTIONS = `${prefix}_SET_TRIGGER_META_OBJECT_OPTIONS`;
export const SET_META_FIELDS_DATA = `${prefix}_SET_META_FIELDS_DATA`;
export const RESET_META_DATA = `${prefix}_RESET_META_DATA`;

// Trigger Type
export const ADD_TRIGGER = `${prefix}_ADD_TRIGGER`;
export const REMOVE_TRIGGER = `${prefix}_REMOVE_TRIGGER`;
export const SET_TRIGGER_OBJECT_KEY = `${prefix}_SET_TRIGGER_OBJECT_KEY`;
export const RESET_TRIGGER = `${prefix}_RESET_TRIGGER`;
export const ADD_TRIGGER_ACTION = `${prefix}_ADD_TRIGGER_ACTION`;
export const UPDATE_TRIGGER_ACTION_FILTER_VALUE = `${prefix}_UPDATE_TRIGGER_ACTION_FILTER_VALUE`;
export const REMOVE_SESSION_FILTER = `${prefix}_REMOVE_SESSION_FILTER`;
export const SET_ALL_TRIGGER_ACTION = `${prefix}_SET_ALL_TRIGGER_ACTION`;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/actionTypes.js